<!--⚠️ This Component is unused⚠️-->
<template>
  <div class="message-list__normal-text">
    <div class="message-container">
      <div ref="scrollToElement" />

      <div
        v-for="message in messages"
        :key="message.id"
      >
        <template v-if="message.participant">
          <template v-if="message.participant.participantType === 'operator'">
            <OperatorMessageBox :message="message" />
          </template>
          <template
            v-else-if="message.participant.participantType === 'customer'"
          >
            <VisitorMessageBox :message="message" />
          </template>
          <template
            v-else-if="message.participant.participantType === 'system'"
          >
            <SystemMessageBox :message="message" />
          </template>
        </template>
        <template v-else>
          <UndefinedMessageBox :message="message" />
        </template>
      </div>

      <!--      <OperatorMessageBox />-->
      <!--      <VisitorMessageBox />-->
      <!--      <SystemMessageBox />-->
    </div>
  </div>
</template>

<script>
import OperatorMessageBox from '@/views/ticket/ticketCenterBody/ticketMessageBox/OperatorMessageBox.vue'
import VisitorMessageBox from '@/views/ticket/ticketCenterBody/ticketMessageBox/VisitorMessageBox.vue'
import SystemMessageBox from '@/views/ticket/ticketCenterBody/ticketMessageBox/SystemMessageBox.vue'
import UndefinedMessageBox from '@/views/ticket/ticketCenterBody/ticketMessageBox/UndefinedMessageBox.vue'

export default {
  components: {
    UndefinedMessageBox,
    SystemMessageBox,
    VisitorMessageBox,
    OperatorMessageBox,
  },
  props: {
    messages: {
      type: Array,
      default: () => [],
    },
    scrollToElement: {
      type: Function,
      default: () => {},
    },
  },
  created() {
    // this.scrollToElement()
  },
  methods: {

  },
}
</script>

<style lang="scss" scoped>
.message-list {
  overflow-y: scroll;
  overflow-x: hidden;
}
.message-container {
  display: flex;
  flex-direction: column-reverse;
  //height: 100%;
  //overflow-y: scroll;
}
.message-list__normal-text {
  @extend .message-list;
  height: calc(100vh - 350px);
  display: flex;
  flex-direction: column-reverse;
}
.message-list__rich-text {
  @extend .message-list;
  height: calc(100vh - 525px);
  display: flex;
  flex-direction: column-reverse;
}
</style>
